import type { XZReport } from "@/androidPlugins/IReports"
import { IPrinter } from "@/androidPlugins/IPrinter"
import { getPositiveXZReportHeader } from "./formatPositiveZReport"

const { formatToMerchantCurrencyString } = useCurrency()

export const printPositiveXReport = async (
  report: XZReport
) => {
  if (report.nativeReceiptLines.length > 0) {
    const formattedReceipt = formatReceipt(
      report.nativeReceiptLines
    )
    await IPrinter.printStr({ str: formattedReceipt })
    return
  }

  const reportString =
    getPositiveXZReportHeader("X REPORT") +
    getDoubleDataLine(
      "Sales",
      report.saleCount.toString(),
      formatToMerchantCurrencyString(report.saleAmount)
    ) +
    getDoubleDataLine(
      "Completions",
      report.completionCount.toString(),
      formatToMerchantCurrencyString(
        report.completionAmount
      )
    ) +
    getDoubleDataLine(
      "Refunds",
      report.refundCount.toString(),
      formatToMerchantCurrencyString(report.refundAmount)
    ) +
    getDataLine(
      formatToMerchantCurrencyString(report.totalAmount),
      "TOTAL"
    ) +
    getBlankLines(1) +
    "Inclusive Of \n" +
    getDoubleDataLine(
      "GRATUITY",
      report.gratuityCount.toString(),
      formatToMerchantCurrencyString(report.gratuityAmount)
    ) +
    getDoubleDataLine(
      "CASHBACK",
      report.cashbackCount.toString(),
      formatToMerchantCurrencyString(report.cashbackAmount)
    )

  await IPrinter.printStr({ str: reportString })
}
